import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/browse/(browse-tabs)/words",
      },
      queries: [],
    }),
    [],
  );
}

export const useBrowseWordsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
